export const breakpoints = ['40em', '52em', '64em'];
